export const sharedProps = {
  type: "checkbox",
  required: false
};

export const EMAIL_ADDRESS_ERROR_MESSAGE = "Error: Must be a valid email address";
export const ONE_OR_MORE_FAILURES_ERROR_MESSAGE =
  "Error: One or more of the newsletters you selected is not available at the moment.";
export const GENERIC_EMAIL_SIGNUP_SALESFORCE_ERROR_MESSAGE =
  "We are experiencing issues with our subscription system. Please try again or come back soon to complete your sign-up.";

// Future work: Move these ids to Contentful so they can be adjusted as needed.
export const contentPreferences = {
  "newsletters-select-goa": "Mission_GOA",
  "newsletters-select-mbka": "Mission_MBKA",
  "newsletters-select-opc": "Mission_OPC",
  "newsletters-select-general": null, //We purposely don't set this
  "newsletters-select-chicago": "Mission_Chicago_Newsletter"
};

/*
  State is an object with the same keys as the contentPreferences object with true or false
  indicating whether they have been selected.
  Returns: CSV string of content preferences.
*/
export function listContentPreferencesFromState(state) {
  let ids = new Set();
  for (let newsletter in state) {
    if (state[newsletter] && contentPreferences[newsletter]) {
      ids.add(contentPreferences[newsletter]);
    }
  }
  return Array.from(ids).join().toLocaleLowerCase();
}

export const newsletterKeys = {
  "Sign up for all newsletters": {
    fieldType: "checkboxField",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-all`,
      label: "Sign up for all newsletters",
      labelClass: "font-bold",
      id: `newsletters-select-all`
    }
  },
  "The Girls Opportunity Alliance": {
    fieldType: "checkboxField",
    descriptionField: "goaDescription",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-goa`,
      label: "The Girls Opportunity Alliance",
      labelClass: "font-bold",
      id: `newsletters-select-goa`
    }
  },
  "My Brother's Keeper Alliance": {
    fieldType: "checkboxField",
    descriptionField: "mbkaDescription",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-mbka`,
      label: "My Brother's Keeper Alliance",
      labelClass: "font-bold",
      id: `newsletters-select-mbka`
    }
  },
  "The Obama Presidential Center": {
    fieldType: "checkboxField",
    descriptionField: "opcDescription",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-opc`,
      label: "The Obama Presidential Center",
      labelClass: "font-bold",
      id: `newsletters-select-opc`
    }
  },
  "General News and Updates": {
    fieldType: "checkboxField",
    descriptionField: "generalDescription",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-general`,
      label: "General News and Updates",
      labelClass: "font-bold",
      id: `newsletters-select-general`
    }
  },

  // not enabled currently and may be removed soon, but leaving fieldDetailsRichText field so it still works if enabled
  Chicago: {
    fieldType: "checkboxField",
    descriptionField: "chicagoDescription",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-chicago`,
      label: "Chicago",
      labelClass: "font-bold",
      fieldDetailsRichText:
        "There are many exciting things happening at the Obama Foundation—across the country and the world, but some of the most important work is happening right here in Chicago. We're building a new landmark for the South Side and economic engine for the city with the Obama Presidential Center, in addition to launching new programming, hosting community events, and driving workforce efforts on our beloved South Side.",
      id: `newsletters-select-chicago`
    }
  }
};
